module.exports = __webpack_public_path__ + "img/1.87bf880d.jpeg";